import { render, staticRenderFns } from "./SimplifiedPrincipalInformations.vue?vue&type=template&id=50321125&"
import script from "./SimplifiedPrincipalInformations.vue?vue&type=script&lang=js&"
export * from "./SimplifiedPrincipalInformations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports